import axios from 'axios';

import {getRequestData} from '../../../containers/Construction/construction.reducer';

const actionTypes = {
  OPEN: 'DRAWER/OPEN',
  CLOSE: 'DRAWER/CLOSE',
  CHANGE_PAYMENT_TYPE: 'DRAWER/CHANGE_PAYMENT_TYPE',
  CHANGE_PAYMENT_VENDOR: 'DRAWER/CHANGE_PAYMENT_VENDOR'
};

const initialState = {
  isOpen: false,
  formType: null,
  paymentType: process.env.REACT_APP_LOCALE === 'hu' ? '0percent' : '30percent',
  paymentVendor: process.env.REACT_APP_LOCALE === 'lt' || process.env.REACT_APP_LOCALE === 'pl' ? 'tpay'
    : process.env.REACT_APP_LOCALE === 'hu' ? 'cash'
      : 'klarna'

};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.OPEN: {
      return {
        ...state,
        isOpen: true,
        formType: action.payload
      };
    }

    case actionTypes.CLOSE: {
      return {
        ...state,
        isOpen: false
      };
    }

    case actionTypes.CHANGE_PAYMENT_TYPE: {
      return {
        ...state,
        paymentType: action.payload
      };
    }

    case actionTypes.CHANGE_PAYMENT_VENDOR: {
      return {
        ...state,
        paymentVendor: action.payload
      };
    }

    default:
      return state;
  }
}

export const open = (formType) => (dispatch) => {
  dispatch({
    type: actionTypes.OPEN,
    payload: formType
  });
};

export const close = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLOSE
  });
};

export const changePaymentType = (paymentType) => (dispatch) => {
  dispatch({
    type: actionTypes.CHANGE_PAYMENT_TYPE,
    payload: paymentType
  });
};

export const changePaymentVendor = (paymentVendor) => (dispatch) => {
  dispatch({
    type: actionTypes.CHANGE_PAYMENT_VENDOR,
    payload: paymentVendor
  });
};

export const handleSubmit = (values) => (dispatch, getStore) => {
  const {formType, paymentType, paymentVendor} = getStore().Drawer;
  const requestData = dispatch(getRequestData(true));

  if (!values.descriptions) {
    // eslint-disable-next-line no-param-reassign
    values.descriptions = 'Brak';
  }

  requestData.customer = {
    ...values
  };

  requestData.online_payment = {
    type: paymentType,
    vendor: paymentVendor
  };

  if (formType === 'buy') {
    return axios.post('buy', requestData);
  }

  if (formType === 'contact') {
    return axios.post('custom', values);
  }

  if (formType === 'pdfExport') {
    return axios.post('generate-pdf', requestData, {responseType: 'blob'});
  }
};
